module.exports = __webpack_public_path__ + "images/xl_guangxi.png?26bcaa7b1cf13f834afd7c9b55f34e6d";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_guangxi.png
// module id = 238
// module chunks = 1